import { OrderStateEnum } from "../../types/enums";

export type BadgeVariant = "attention" | "error" | "information" | "neutral" | "special" | "success" | "warning";

export const statusVariant = (status: OrderStateEnum | undefined): BadgeVariant => {
    switch (status) {
        case OrderStateEnum.COMPLETED:
        case OrderStateEnum.FINALIZED:
            return "success";
        case OrderStateEnum.SUBMITTED:
        case OrderStateEnum.COMMITTED:
        case OrderStateEnum.READY_TO_COMMIT:
        case OrderStateEnum.READY_TO_AUTHENTICATE:
            return "attention";
        case OrderStateEnum.CANCELLED:
        case OrderStateEnum.DECLINED:
        case OrderStateEnum.ABANDONED:
            return "error";
        case OrderStateEnum.INTERNAL_MANUAL_ATTENTION_REQUIRED:
        case OrderStateEnum.MANUAL_ATTENTION_REQUIRED_BY_DEALER:
            return "warning";
        case OrderStateEnum.INITIALIZED:
        case OrderStateEnum.RESERVED:
        default:
            return "neutral";
    }
};

export const getStatusText = (status: OrderStateEnum | undefined): string => {
    switch (status) {
        case OrderStateEnum.ABANDONED:
            return "Forlatt";
        case OrderStateEnum.CANCELLED:
            return "Kansellert";
        case OrderStateEnum.COMMITTED:
            return "Bekreftet";
        case OrderStateEnum.COMPLETED:
            return "Fullført";
        case OrderStateEnum.DECLINED:
            return "Avvist";
        case OrderStateEnum.FINALIZED:
            return "Behandles";
        case OrderStateEnum.INITIALIZED:
            return "Påbegynt";
        case OrderStateEnum.INTERNAL_MANUAL_ATTENTION_REQUIRED:
            return "Krever intern oppfølging";
        case OrderStateEnum.MANUAL_ATTENTION_REQUIRED_BY_DEALER:
            return "Krever oppfølging av selger";
        case OrderStateEnum.READY_TO_AUTHENTICATE:
            return "Venter på signering";
        case OrderStateEnum.READY_TO_COMMIT:
            return "Klar til bekreftelse";
        case OrderStateEnum.RESERVED:
            return "Reservert";
        case OrderStateEnum.SUBMITTED:
            return "Sendt inn (ikke signert)";
        default:
            return status || "Ukjent status";
    }
};
